import { useRef } from 'react';
import { ReactComponent as ArrowDropUpIcon } from '../../../assets/icons/arrow-drop-up.svg';
import { ReactComponent as ArrowDropDownIcon } from '../../../assets/icons/arrow-drop-down.svg';

export const NumberInputV2 = (props: React.InputHTMLAttributes<HTMLInputElement>): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="core-number-input__container">
      <input className="core-number-input__input" ref={inputRef} type="number" {...props}></input>
      <div className="core-number-input__spinner-container">
        <button
          className="core-number-input__spinner-button"
          aria-label="Increment"
          type="button"
          tabIndex={-1}
          onMouseDown={(e) => e.preventDefault()}
          disabled={props.disabled}
          onClick={() => {
            inputRef.current?.focus();
            inputRef.current?.stepUp();
            inputRef.current?.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          }}
        >
          <ArrowDropUpIcon />
        </button>
        <button
          className="core-number-input__spinner-button"
          aria-label="Decrement"
          type="button"
          tabIndex={-1}
          onMouseDown={(e) => e.preventDefault()}
          disabled={props.disabled}
          onClick={() => {
            inputRef.current?.focus();
            inputRef.current?.stepDown();
            inputRef.current?.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          }}
        >
          <ArrowDropDownIcon />
        </button>
      </div>
      {props.disabled && <div className="core-number-input__container-overlay" />}
    </div>
  );
};
